import React, { useState, useEffect } from "react";
import { Box, SxProps, Typography } from "@mui/material";
import { useConfig, formatPrice } from "@thekilroygroup/shared-ui";
import { useCountUp } from "use-count-up";

export const PaymentLine = (props: {
  amount: number;
  label: string;
  currency: string;
}) => {
  const { amount, label, currency } = props;

  const { locale } = useConfig();

  const [lowestTotalAmount, setLowestTotalAmount] = useState(0);

  const [localLowestTotalAmount, setLocalLowestTotalAmount] =
    useState(lowestTotalAmount);

  useEffect(() => {
    setLowestTotalAmount(amount);
  }, [amount]);

  useEffect(() => {
    countLowestTotalAmount();
  }, [lowestTotalAmount, amount]);

  const { value: animatedLowestTotalAmount, reset: countLowestTotalAmount } =
    useCountUp({
      isCounting: true,
      start: localLowestTotalAmount,
      end: lowestTotalAmount,
      duration: 0.4,
      onComplete: () => {
        setLocalLowestTotalAmount(lowestTotalAmount);
      },
    });
  return (
    <Box
      sx={{
        mb: 1,
      }}
    >
      <Box sx={rowStyles}>
        <Typography variant="bodyMedium">{label}</Typography>
        <Typography variant="titleMedium" weight="bold">
          {formatPrice(animatedLowestTotalAmount, locale, currency)}
        </Typography>
      </Box>
    </Box>
  );
};

const rowStyles: SxProps = {
  display: "flex",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  gap: 8,
};
